import React from 'react';
import { API_BASE_URL } from '../api/kiteApi';

export default function RealLogin() {
  const startLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/login`;
  };

  return (
    <div className="auth-page">
      <section className="auth-card">
        <div className="auth-visual" aria-hidden="true">
          <span className="auth-orbit auth-orbit-one" />
          <span className="auth-orbit auth-orbit-two" />
          <div className="auth-chart">
            <span /><span /><span /><span /><span />
          </div>
          <p>Real trades stay broker-connected and risk checked.</p>
        </div>
        <div className="auth-content">
          <div className="eyebrow">Real trading login</div>
          <h1>Connect your Kite account.</h1>
          <p>Use this area only for real trades, holdings, positions, and live portfolio management.</p>
          <button className="button button-primary button-large" onClick={startLogin}>
            Connect with Kite <span>&rarr;</span>
          </button>
          <div className="auth-assurance">
            <span>Secure OAuth</span>
            <span>Kite only</span>
          </div>
        </div>
      </section>
    </div>
  );
}
